// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rec-selector-menu__break[data-v-644dba4e]{border-top:0.0625rem solid var(--p-d-20);margin:1.25rem 1.125rem}.rec-selector-menu__group-header[data-v-644dba4e]{color:var(--text-color-dark);font-weight:700;text-transform:uppercase;font-size:0.75rem;padding:0.3125rem 1.125rem}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
